import { render } from "./TrainingProgramAccordionInformationsComponent.vue?vue&type=template&id=602b8ac6&scoped=true"
import script from "./TrainingProgramAccordionInformationsComponent.vue?vue&type=script&lang=js"
export * from "./TrainingProgramAccordionInformationsComponent.vue?vue&type=script&lang=js"

import "./TrainingProgramAccordionInformationsComponent.vue?vue&type=style&index=0&id=602b8ac6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-602b8ac6"]])

export default __exports__